export const iconFontAwesomeEducationChalkboard = (
	<i className="fa-solid fa-chalkboard"></i>
);
